import React, { useEffect, useState } from 'react';
import { useNavigate }                from 'react-router-dom';
import { useAuth }                    from '../contexts/AuthContext';
import { getAllSuppliers }             from '../api/parts';

export default function SuppliersPage() {
  const { user, signOut } = useAuth();
  const navigate          = useNavigate();

  const [suppliers, setSuppliers] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState('');
  const [search,    setSearch]    = useState('');

  useEffect(() => {
    getAllSuppliers()
      .then(res => {
        if (res.success) setSuppliers(res.data || []);
        else setError(res.message || 'Could not load suppliers.');
      })
      .catch(() => setError('Could not load suppliers.'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = search.trim()
    ? suppliers.filter(s =>
        (s.name    || '').toLowerCase().includes(search.toLowerCase()) ||
        (s.website || '').toLowerCase().includes(search.toLowerCase())
      )
    : suppliers;

  return (
    <div className="pts-root">

      {/* ── Header ──────────────────────────────────────────────────── */}
      <header className="pts-header">
        <div className="pts-header-brand">
          <span className="pts-header-gear">⚙</span>
          <span className="pts-header-name">AutoRestoration</span>
        </div>
        <div className="pts-header-vehicle" />
        <div className="pts-header-user">
          <span className="pts-username">@{user?.username}</span>
          <button className="pts-signout-btn" onClick={() => { signOut(); navigate('/'); }}>Sign Out</button>
        </div>
      </header>

      {/* ── Body ────────────────────────────────────────────────────── */}
      <div className="pts-body">

        <button className="pts-back-dash" onClick={() => navigate('/dashboard')}>
          ← Dashboard
        </button>

        <div className="pts-page-title-row">
          <div className="pts-breadcrumb">
            <span className="pts-crumb pts-crumb-active">🏪 Suppliers</span>
          </div>
        </div>

        {/* Search */}
        {!loading && !error && suppliers.length > 0 && (
          <input
            style={{
              background: '#1e2839', color: '#ccc', border: '1px solid #3a4a5a',
              borderRadius: 6, padding: '8px 14px', fontSize: '0.9rem',
              width: '100%', maxWidth: 400, marginBottom: 16, boxSizing: 'border-box',
            }}
            placeholder="Search by name or website…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        )}

        {loading && <div className="pts-loading">Loading suppliers…</div>}
        {!loading && error && <div className="pts-error">{error}</div>}

        {!loading && !error && suppliers.length === 0 && (
          <div className="pts-empty">
            <div className="pts-empty-icon">🏪</div>
            <h3 className="pts-empty-title">No suppliers yet</h3>
            <p className="pts-empty-text">
              Add suppliers to parts via the Part Detail page and they will appear here.
            </p>
          </div>
        )}

        {!loading && filtered.length > 0 && (
          <div className="pts-parts-section">
            <div className="pts-parts-header-row">
              <span className="pts-parts-count">
                {filtered.length} supplier{filtered.length !== 1 ? 's' : ''}
                {search && suppliers.length !== filtered.length
                  ? ` of ${suppliers.length}`
                  : ''}
              </span>
            </div>

            <div className="pts-parts-list">
              {filtered.map(s => (
                <div key={s.supplierId} className="pts-part-card">

                  <div className="pts-part-main">
                    <span className="pts-part-name">{s.name}</span>
                    {s.website && (
                      <a
                        href={s.website.startsWith('http') ? s.website : `https://${s.website}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: '#6af', fontSize: '0.82rem', marginLeft: 8 }}
                        onClick={e => e.stopPropagation()}
                      >
                        {s.website}
                      </a>
                    )}
                  </div>

                  <div className="pts-part-meta" style={{ marginTop: 4 }}>
                    {s.active_listing_count > 0 && (
                      <span className="pts-part-flag">
                        {s.active_listing_count} listing{s.active_listing_count !== 1 ? 's' : ''}
                      </span>
                    )}
                    {s.part_count > 0 && (
                      <span className="pts-part-flag">
                        {s.part_count} part{s.part_count !== 1 ? 's' : ''}
                      </span>
                    )}
                    {s.phone && (
                      <span className="pts-part-flag" title="Phone">📞 {s.phone}</span>
                    )}
                    {s.email && (
                      <span className="pts-part-flag" title="Email">✉ {s.email}</span>
                    )}
                    {s.active_listing_count === 0 && s.part_count === 0 && (
                      <span className="pts-part-flag" style={{ color: '#888' }}>No active listings</span>
                    )}
                  </div>

                </div>
              ))}
            </div>
          </div>
        )}

        {/* No results after search */}
        {!loading && !error && suppliers.length > 0 && filtered.length === 0 && (
          <div className="pts-empty">
            <div className="pts-empty-icon">🔍</div>
            <h3 className="pts-empty-title">No matches</h3>
            <p className="pts-empty-text">No suppliers match "{search}".</p>
          </div>
        )}

      </div>
    </div>
  );
}
